var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"printerWrapper",attrs:{"id":_vm.$attrs['id']}},[(_vm.loading)?_c('spinner-overlay'):_vm._e(),_vm._v(" "),_c('iframe',{ref:"printeriframe",attrs:{"id":"printeriframe","src":"about:blank"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03201092","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/lib/util/Printer.vue
// module id = dEhE
// module chunks = 0